import { EXCEED_MAXIMUM_FILE_SIZE_ALARM_IS_PROMPTED } from '@core/transmission/TransmissionNoticeManager'
import { INSTANCE as cloudAdapter } from '@/netadapters/CloudAdapter'
import { TimeConstants } from '@core/Constants'
import { debounce } from 'lodash'
import { Env } from '@core/EnvUtils'
import { LAN_AVAILABILITY_IS_PROMPTED } from '@core/transmission/CertificateManager'

export interface ILoginListener {
  onLogout: () => void
}

export class LoginManager {
  #loginListener = new Set<ILoginListener>()

  logout = debounce(
    (callbackUrl?: string) => {
      window.localStorage.removeItem(EXCEED_MAXIMUM_FILE_SIZE_ALARM_IS_PROMPTED)
      window.localStorage.removeItem(LAN_AVAILABILITY_IS_PROMPTED)
      this.#logoutImpl(callbackUrl)
    },
    TimeConstants.DEFAULT_DEBOUNCING_IN_MS,
    { leading: true, trailing: false }
  )

  async addListener(listener: ILoginListener) {
    if (!this.#loginListener.has(listener)) {
      this.#loginListener.add(listener)
    }
  }

  removeListener(listener: ILoginListener) {
    this.#loginListener.delete(listener)
  }

  async #logoutImpl(callbackUrl?: string) {
    await cloudAdapter.logout()
    this.#notifyLogoutListener()

    if (callbackUrl) window.location.replace(callbackUrl)
  }

  #notifyLogoutListener() {
    for (const listener of this.#loginListener) {
      try {
        listener.onLogout()
      } catch (error) {
        // 在登录和登出过程中，不能因为一个模块而堵塞项目加载
        if (!Env.isRelease()) {
          throw error
        }
      }
    }
  }
}

const __INSTANCE = new LoginManager()

export default {
  getInstance: () => __INSTANCE,
}
